import repository from "../Repository";

export default {
  async list(screenId, municip_code) {
    return await repository.post(
      "disaster_prevention_fa_info",
      {
        municip_code
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async create(screenId, payload) {
    return await repository.post("disaster_prevention_fa_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.patch("disaster_prevention_fa_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async delete(screenId, payload) {
    return await repository.patch(
      "disaster_prevention_fa_ope/delete",
      payload,
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
